// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 30 30%27%3e%3cpath stroke=%27rgba%280,0,0,0.9%29%27 stroke-linecap=%27round%27 stroke-miterlimit=%2710%27 stroke-width=%272%27 d=%27M4 7h22M4 15h22M4 23h22%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ------------------------------------------------------------------
   Navbar — supplementary styles
   Additive layer on top of the existing tc-navbar-style1 theme classes.
-------------------------------------------------------------------*/

.nav-style2 {
  position: fixed !important;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 9999;
  background-color: transparent;
  border-bottom: 1px solid transparent;
  transition: background-color 0.35s ease, box-shadow 0.35s ease,
    padding 0.35s ease, border-color 0.35s ease;
  padding-top: 18px;
  padding-bottom: 18px;
}

.nav-style2.is-scrolled {
  /* background-color: rgba(15, 15, 15, 0.92); */
background-color: white;
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  box-shadow: 0 6px 24px rgba(0, 0, 0, 0.18);
  border-bottom-color: rgba(255, 255, 255, 0.08);
  padding-top: 8px;
  padding-bottom: 8px;
}

.nav-style2 .logo {
  transition: height 0.35s ease, transform 0.35s ease;
}

.nav-style2.is-scrolled .logo {
  transform: scale(0.92);
}

.nav-style2 .nav-menu-style1 .nav-item {
  position: relative;
  margin: 0 4px;
}

.nav-style2 .nav-menu-style1 .nav-link {
  position: relative;
  padding: 8px 14px !important;
}

.nav-style2 .nav-menu-style1 .nav-link::after {
  content: '';
  position: absolute;
  left: 14px;
  right: 14px;
  bottom: 2px;
  height: 2px;
  background: currentColor;
  opacity: 0.85;
  transform: scaleX(0);
  transform-origin: left;
  transition: transform 0.3s ease;
}

.nav-style2 .nav-menu-style1 .nav-link:hover::after,
.nav-style2 .nav-menu-style1 .nav-link.active::after {
  transform: scaleX(1);
}

.nav-style2 .dropdown-menu {
  border: none;
  border-radius: 12px;
  box-shadow: 0 18px 42px rgba(0, 0, 0, 0.2);
  padding: 10px;
  margin-top: 14px !important;
}

.nav-style2 .dropdown-item {
  border-radius: 8px;
  padding: 10px 14px;
  transition: background-color 0.2s ease, padding-left 0.2s ease;
}

.nav-style2 .dropdown-item:hover {
  background-color: rgba(0, 0, 0, 0.05);
  padding-left: 18px;
}

@media (min-width: 992px) {
  .nav-style2 .dropdown-menu {
    opacity: 0;
    visibility: hidden;
    display: block;
    transform: translateY(8px);
    pointer-events: none;
    transition: opacity 0.25s ease, transform 0.25s ease, visibility 0.25s ease;
  }

  .nav-style2 .dropdown:hover .dropdown-menu {
    opacity: 1;
    visibility: visible;
    transform: translateY(0);
    pointer-events: auto;
  }
}

.nav-style2 .nav-social-style1 {
  display: flex;
  align-items: center;
  gap: 8px;
  list-style: none;
  margin: 0;
  padding: 0;
}

.nav-style2 .nav-social-style1 a {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  border: 1px solid rgba(255, 255, 255, 0.25);
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background-color 0.3s ease, transform 0.3s ease, border-color 0.3s ease;
}

.nav-style2 .nav-social-style1 a:hover {
  /*background-color: rgba(255, 255, 255, 0.15);*/
  border-color: rgba(255, 255, 255, 0.5);
  transform: translateY(-2px);
}

@media (max-width: 991px) {
  .nav-style2 {
    background-color: rgba(15, 15, 15, 0.95);
  }

  .nav-style2 .navbar-collapse {
    margin-top: 16px;
    padding: 20px;
    background: #111111;
    border-radius: 12px;
  }

  .nav-style2 .nav-side {
    margin-top: 16px;
  }
}
@media (max-width: 991px) {
  .nav-style2 {
    background-color: rgba(15, 15, 15, 0.95);
    padding-top: 14px;
    padding-bottom: 14px;
  }

  .nav-style2.is-scrolled {
    padding-top: 10px;
    padding-bottom: 10px;
  }

  .nav-style2 .logo {
    height: 32px;
  }

  /* Bootstrap's default toggler icon is dark-stroke; force a light one
     since this navbar is always on a dark/transparent background */
  .nav-style2 .navbar-toggler {
    border: none;
    padding: 4px 8px;
  }

  .nav-style2 .navbar-toggler:focus {
    box-shadow: none;
  }

 .nav-style2 .navbar-toggler-icon {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}
  .nav-style2 .navbar-collapse {
    margin-top: 16px;
    padding: 20px;
    background: white;
    border-radius: 12px;
    max-height: 75vh;
    overflow-y: auto;
  }

  .nav-style2 .nav-menu-style1 {
    width: 100%;
  }

  .nav-style2 .nav-menu-style1 .nav-item {
    margin: 0;
    width: 100%;
  }

  .nav-style2 .nav-menu-style1 .nav-link {
    padding: 12px 4px !important;
    width: 100%;
  }

  .nav-style2 .nav-menu-style1 .nav-link::after {
    display: none; /* underline hover effect doesn't make sense in a stacked mobile list */
  }

  /* Dropdown becomes an inline expanding submenu instead of a floating panel */
  .nav-style2 .dropdown-menu {
    position: static;
    box-shadow: none;
    background: rgba(255, 255, 255, 0.04);
    margin-top: 8px !important;
    margin-left: 8px;
  }

  .nav-style2 .nav-side {
    margin-top: 16px;
    width: 100%;
  }

  .nav-style2 .nav-social-style1 {
    flex-wrap: wrap;
  }
}

@media (max-width: 575px) {
  .nav-style2 .logo {
    height: 40px;
  }

  .nav-style2 .navbar-collapse {
    padding: 16px;
  }

  .nav-style2 .nav-social-style1 a {
    width: 32px;
    height: 32px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/home1/navbar-style.css"],"names":[],"mappings":"AAAA;;;oEAGoE;;AAEpE;EACE,0BAA0B;EAC1B,MAAM;EACN,OAAO;EACP,WAAW;EACX,aAAa;EACb,6BAA6B;EAC7B,oCAAoC;EACpC;+CAC6C;EAC7C,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,8CAA8C;AAChD,uBAAuB;EACrB,2BAA2B;EAC3B,mCAAmC;EACnC,0CAA0C;EAC1C,8CAA8C;EAC9C,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,mDAAmD;AACrD;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,WAAW;EACX,WAAW;EACX,wBAAwB;EACxB,aAAa;EACb,oBAAoB;EACpB,sBAAsB;EACtB,+BAA+B;AACjC;;AAEA;;EAEE,oBAAoB;AACtB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,0CAA0C;EAC1C,aAAa;EACb,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,8DAA8D;AAChE;;AAEA;EACE,qCAAqC;EACrC,kBAAkB;AACpB;;AAEA;EACE;IACE,UAAU;IACV,kBAAkB;IAClB,cAAc;IACd,0BAA0B;IAC1B,oBAAoB;IACpB,2EAA2E;EAC7E;;EAEA;IACE,UAAU;IACV,mBAAmB;IACnB,wBAAwB;IACxB,oBAAoB;EACtB;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,2CAA2C;EAC3C,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mFAAmF;AACrF;;AAEA;EACE,+CAA+C;EAC/C,sCAAsC;EACtC,2BAA2B;AAC7B;;AAEA;EACE;IACE,wCAAwC;EAC1C;;EAEA;IACE,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;EAClB;AACF;AACA;EACE;IACE,wCAAwC;IACxC,iBAAiB;IACjB,oBAAoB;EACtB;;EAEA;IACE,iBAAiB;IACjB,oBAAoB;EACtB;;EAEA;IACE,YAAY;EACd;;EAEA;mEACiE;EACjE;IACE,YAAY;IACZ,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;CAED;IACG,yDAAqP;AACzP;EACE;IACE,gBAAgB;IAChB,aAAa;IACb,iBAAiB;IACjB,mBAAmB;IACnB,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,SAAS;IACT,WAAW;EACb;;EAEA;IACE,4BAA4B;IAC5B,WAAW;EACb;;EAEA;IACE,aAAa,EAAE,uEAAuE;EACxF;;EAEA,6EAA6E;EAC7E;IACE,gBAAgB;IAChB,gBAAgB;IAChB,qCAAqC;IACrC,0BAA0B;IAC1B,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;IAChB,WAAW;EACb;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,YAAY;EACd;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,WAAW;IACX,YAAY;EACd;AACF","sourcesContent":["/* ------------------------------------------------------------------\n   Navbar — supplementary styles\n   Additive layer on top of the existing tc-navbar-style1 theme classes.\n-------------------------------------------------------------------*/\n\n.nav-style2 {\n  position: fixed !important;\n  top: 0;\n  left: 0;\n  width: 100%;\n  z-index: 9999;\n  background-color: transparent;\n  border-bottom: 1px solid transparent;\n  transition: background-color 0.35s ease, box-shadow 0.35s ease,\n    padding 0.35s ease, border-color 0.35s ease;\n  padding-top: 18px;\n  padding-bottom: 18px;\n}\n\n.nav-style2.is-scrolled {\n  /* background-color: rgba(15, 15, 15, 0.92); */\nbackground-color: white;\n  backdrop-filter: blur(10px);\n  -webkit-backdrop-filter: blur(10px);\n  box-shadow: 0 6px 24px rgba(0, 0, 0, 0.18);\n  border-bottom-color: rgba(255, 255, 255, 0.08);\n  padding-top: 8px;\n  padding-bottom: 8px;\n}\n\n.nav-style2 .logo {\n  transition: height 0.35s ease, transform 0.35s ease;\n}\n\n.nav-style2.is-scrolled .logo {\n  transform: scale(0.92);\n}\n\n.nav-style2 .nav-menu-style1 .nav-item {\n  position: relative;\n  margin: 0 4px;\n}\n\n.nav-style2 .nav-menu-style1 .nav-link {\n  position: relative;\n  padding: 8px 14px !important;\n}\n\n.nav-style2 .nav-menu-style1 .nav-link::after {\n  content: '';\n  position: absolute;\n  left: 14px;\n  right: 14px;\n  bottom: 2px;\n  height: 2px;\n  background: currentColor;\n  opacity: 0.85;\n  transform: scaleX(0);\n  transform-origin: left;\n  transition: transform 0.3s ease;\n}\n\n.nav-style2 .nav-menu-style1 .nav-link:hover::after,\n.nav-style2 .nav-menu-style1 .nav-link.active::after {\n  transform: scaleX(1);\n}\n\n.nav-style2 .dropdown-menu {\n  border: none;\n  border-radius: 12px;\n  box-shadow: 0 18px 42px rgba(0, 0, 0, 0.2);\n  padding: 10px;\n  margin-top: 14px !important;\n}\n\n.nav-style2 .dropdown-item {\n  border-radius: 8px;\n  padding: 10px 14px;\n  transition: background-color 0.2s ease, padding-left 0.2s ease;\n}\n\n.nav-style2 .dropdown-item:hover {\n  background-color: rgba(0, 0, 0, 0.05);\n  padding-left: 18px;\n}\n\n@media (min-width: 992px) {\n  .nav-style2 .dropdown-menu {\n    opacity: 0;\n    visibility: hidden;\n    display: block;\n    transform: translateY(8px);\n    pointer-events: none;\n    transition: opacity 0.25s ease, transform 0.25s ease, visibility 0.25s ease;\n  }\n\n  .nav-style2 .dropdown:hover .dropdown-menu {\n    opacity: 1;\n    visibility: visible;\n    transform: translateY(0);\n    pointer-events: auto;\n  }\n}\n\n.nav-style2 .nav-social-style1 {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  list-style: none;\n  margin: 0;\n  padding: 0;\n}\n\n.nav-style2 .nav-social-style1 a {\n  width: 36px;\n  height: 36px;\n  border-radius: 50%;\n  border: 1px solid rgba(255, 255, 255, 0.25);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: background-color 0.3s ease, transform 0.3s ease, border-color 0.3s ease;\n}\n\n.nav-style2 .nav-social-style1 a:hover {\n  /*background-color: rgba(255, 255, 255, 0.15);*/\n  border-color: rgba(255, 255, 255, 0.5);\n  transform: translateY(-2px);\n}\n\n@media (max-width: 991px) {\n  .nav-style2 {\n    background-color: rgba(15, 15, 15, 0.95);\n  }\n\n  .nav-style2 .navbar-collapse {\n    margin-top: 16px;\n    padding: 20px;\n    background: #111111;\n    border-radius: 12px;\n  }\n\n  .nav-style2 .nav-side {\n    margin-top: 16px;\n  }\n}\n@media (max-width: 991px) {\n  .nav-style2 {\n    background-color: rgba(15, 15, 15, 0.95);\n    padding-top: 14px;\n    padding-bottom: 14px;\n  }\n\n  .nav-style2.is-scrolled {\n    padding-top: 10px;\n    padding-bottom: 10px;\n  }\n\n  .nav-style2 .logo {\n    height: 32px;\n  }\n\n  /* Bootstrap's default toggler icon is dark-stroke; force a light one\n     since this navbar is always on a dark/transparent background */\n  .nav-style2 .navbar-toggler {\n    border: none;\n    padding: 4px 8px;\n  }\n\n  .nav-style2 .navbar-toggler:focus {\n    box-shadow: none;\n  }\n\n .nav-style2 .navbar-toggler-icon {\n    background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'%3e%3cpath stroke='rgba(0,0,0,0.9)' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/%3e%3c/svg%3e\");\n}\n  .nav-style2 .navbar-collapse {\n    margin-top: 16px;\n    padding: 20px;\n    background: white;\n    border-radius: 12px;\n    max-height: 75vh;\n    overflow-y: auto;\n  }\n\n  .nav-style2 .nav-menu-style1 {\n    width: 100%;\n  }\n\n  .nav-style2 .nav-menu-style1 .nav-item {\n    margin: 0;\n    width: 100%;\n  }\n\n  .nav-style2 .nav-menu-style1 .nav-link {\n    padding: 12px 4px !important;\n    width: 100%;\n  }\n\n  .nav-style2 .nav-menu-style1 .nav-link::after {\n    display: none; /* underline hover effect doesn't make sense in a stacked mobile list */\n  }\n\n  /* Dropdown becomes an inline expanding submenu instead of a floating panel */\n  .nav-style2 .dropdown-menu {\n    position: static;\n    box-shadow: none;\n    background: rgba(255, 255, 255, 0.04);\n    margin-top: 8px !important;\n    margin-left: 8px;\n  }\n\n  .nav-style2 .nav-side {\n    margin-top: 16px;\n    width: 100%;\n  }\n\n  .nav-style2 .nav-social-style1 {\n    flex-wrap: wrap;\n  }\n}\n\n@media (max-width: 575px) {\n  .nav-style2 .logo {\n    height: 40px;\n  }\n\n  .nav-style2 .navbar-collapse {\n    padding: 16px;\n  }\n\n  .nav-style2 .nav-social-style1 a {\n    width: 32px;\n    height: 32px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
